import React, {useState} from 'react';
import {Select, Typography, Row, Col, Avatar, Card} from 'antd';
import moment  from 'moment';
import Loader from './Loader';

import { useGetCryptoNewsQuery } from '../services/cryptoNewsApi';
import { useGetCryptosQuery } from '../services/cryptoApi'
const { Text, Title } = Typography;
const { Option } = Select;
const demoImage = 'https://img.freepik.com/free-vector/infographic-blockchain-concept_23-2147850239.jpg?t=st=1657902353~exp=1657902953~hmac=a52d7aa1f6ad591e8ab86d27e9adffe4f00915b1b214f529179768a91cfeb1e9&w=100';

function News({simplified}) {
  const [newsCategory, setNewsCategory] = useState('Cryptocurrency')
  const {data: cryptoNews } = useGetCryptoNewsQuery({newsCategory, count: simplified ? 6: 12});
  const {data} = useGetCryptosQuery(100);

  if(!cryptoNews?.value) return <Loader />

  return (
    <div>
      <Row gutter={[24, 24]}>
        {
          !simplified && (
            <Col span={24}>
                <Select showSearch className='select-news' placeholder='select a Crypto' optionFilterProp='children' 
                  onChange={(value) => setNewsCategory(value)}
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLocaleLowerCase()) >= 0}
                >
                    <Option value='Cryptocurrency'>Cryptocurrency</Option>
                    {data?.data?.coins.map((coin) => <Option value={coin.name}>
                      {coin.name}
                    </Option>)}
                </Select>
            </Col>
          )
        }
          {
            cryptoNews.value.map((news, i) => (
              <Col xs={24} sm={12} lg={8} key={i}>
                  <Card hoverable className='news-card'>
                      <a href={news.url} target='_blank' rel='noreferrer'>
                          <div className='news-image-container'>
                             <Title className='news-title' level={4}>
                                  {news.name}
                             </Title>
                             <img style={{ maxWidth: '200px', maxHeight: '100px' }} src={news?.image?.thumbnail?.contentUrl || demoImage} alt='News' />
                          </div>
                          <p>
                            {news.description > 100 
                                ? `${news.description.substring(0, 100)}...`
                                : news.description
                            }
                          </p>
                          <div className="provider-container">
                            <div>
                               <Avatar src={news.provider[0]?.image?.thumbnail?.contentUrl || demoImage}  alt='News'/>
                               <Text className="provider-name">{news.provider[0]?.name}</Text>
                            </div>
                            <Text>{moment(news.datePublished).startOf('ss').fromNow()}</Text>
                          </div>
                      </a>
                  </Card>
              </Col>
            ))
          }
      </Row>
    </div>
  )
}

export default News